export interface PainPoint {
  title: string
  description: string
}

export const painPoints: PainPoint[] = [
  {
    title: 'Non sono un allenatore',
    description:
      'Devi insegnare motoria ma non hai una formazione sportiva, e hai paura di proporre esercizi sbagliati o poco sicuri.',
  },
  {
    title: 'Zero tempo per preparare',
    description:
      'Tra programmazioni, verifiche e burocrazia, non ti resta tempo per costruire una progressione motoria da zero.',
  },
  {
    title: 'Spazio e attrezzi che non ci sono',
    description: 'La palestra è occupata, piove, mancano gli attrezzi: e la lezione va fatta comunque, oggi.',
  },
]
